module.exports = __webpack_public_path__ + "static/media/image_placeholder.abc88cbd.jpeg";